module.exports = __webpack_public_path__ + "img/recommended-bg.6120e79d.svg";